export default {
    namespaced: true,
    state: {
        folderId: null,
    },
    getters: {
        folderId: state => state.folderId,
    },
    mutations: {
        SET_FOLDER_ID(state, payload) {
            state.folderId = payload;
        },
    },
    actions: {
        setFolderId({commit, state}, payload) {
            commit('SET_FOLDER_ID', payload);
        },
    }
}